/**
 * @generated SignedSource<<d6919efa20be1f605b544b2750e3532e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ServiceEditVariantsRow_serviceOption$data = {
  readonly id: string;
  readonly name: string;
  readonly price: number | null;
  readonly scoroProductId: number | null;
  readonly " $fragmentSpreads": FragmentRefs<"SortableEntityTableRow_entity">;
  readonly " $fragmentType": "ServiceEditVariantsRow_serviceOption";
};
export type ServiceEditVariantsRow_serviceOption$key = {
  readonly " $data"?: ServiceEditVariantsRow_serviceOption$data;
  readonly " $fragmentSpreads": FragmentRefs<"ServiceEditVariantsRow_serviceOption">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ServiceEditVariantsRow_serviceOption",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scoroProductId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "price",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SortableEntityTableRow_entity"
    }
  ],
  "type": "ServiceOption",
  "abstractKey": null
};

(node as any).hash = "3a65d47db1ae92f90b4192b297e53281";

export default node;
